import { useContext } from 'react';
import { MediaQuery } from '@ok/okg';
import { Tabs, Skeleton } from '@ok/okd';
import CurrencyInfoContext from '@pages/currencyInfo/context';
import { toLocale } from '@common/i18n';
import { PLACEHOLDER } from '@pages/currencyInfo/common/context';
import Exchange from '../Exchange';
import Trade from '../Trade';
import Staking from '../Staking';
import Twitter from '../Twitter';
import News from '../News';

import './index.less';

export default () => {
  const { currency, currencyInfo, loading } = useContext(CurrencyInfoContext);

  const {
    supportSale,
    supportStaking,
    products: { spot } = {},
    symbol = PLACEHOLDER,
  } = currencyInfo;

  const components = [
    {
      title: toLocale('currency_buy_calculator_title', {
        symbol: symbol,
      }),
      Component: Exchange,
      show: supportSale,
    },
    {
      title: toLocale('currency_trade_title'),
      Component: Trade,
      show: !!spot?.length,
    },
    {
      title: toLocale('currency_staking_title'),
      Component: Staking,
      show: supportStaking,
    },
    {
      title: toLocale('currency_sns_title'),
      Component: Twitter,
    },
    {
      title: toLocale('currency_media_title'),
      Component: News,
    },
  ];

  const contentPc = (
    <>
      {components.map(
        ({ Component, title, show = true }) =>
          show && (
            <div className="right-item-box" key={title}>
              <Component
                title={title}
                currency={currency}
                currencyInfo={currencyInfo}
              />
            </div>
          )
      )}
    </>
  );

  const contentMobile = (
    <Tabs.Underline
      color={Tabs.COLOR.grey}
      key={symbol}
      activeClassName={'currency-info-tabs-active'}
    >
      {components.map(
        ({ Component, title, show = true }) =>
          show && (
            <Tabs.TabPane tab={title} id={title} key={title}>
              <Component currency={currency} currencyInfo={currencyInfo} />
            </Tabs.TabPane>
          )
      )}
    </Tabs.Underline>
  );
  return (
    <div className="right-box">
      {loading ? (
        <Skeleton.Input className="right-box-skeleton" active />
      ) : (
        <MediaQuery md={contentPc} sm={contentMobile} />
      )}
    </div>
  );
};
